export default __webpack_public_path__ + "static/media/const2.2dd8cf79.jpg";